export default {
  section: {
    maxHeight: { xs: 407, md: 588 },
    minHeight: { xs: 407, md: 588 },
    borderRadius: { xs: '0px 0px 24px 24px', lg: 0 },
    paddingTop: { xs: 4, lg: 7 },
    overflow: 'hidden',
    mt: '-1px',
  },
  topBlock: {
    width: { xs: '100%', md: 'fit-content' },
    display: 'flex',
    flexDirection: {
      xs: 'row-reverse',
      md: 'column',
    },
    gap: 2,
    justifyContent: { xs: 'space-between', md: 'flex-start' },
    alignItems: { xs: 'center', md: 'flex-start' },
  },
  title: {
    letterSpacing: '-0.04em !important',
    maxWidth: 512,
    mt: { xs: 2, md: 4 },
    fontSize: {
      xs: 36,
      md: 72,
    },
  },
  description: {
    fontSize: { xs: 16, md: 18 },
    letterSpacing: '-0.005em',
    maxWidth: { xs: '100%', md: 631 },
    mt: { xs: 2, md: 1.5 },
  },
  button: { mt: { xs: 3, md: 4 } },
};
